import { NgModule } from '@angular/core';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { IconComponent } from './icon.component';
import { ClickOutsideDirective } from './click-outside.directive';
import { ClickLoginDirective } from './click-login.directive';
import { ClickLogoutDirective } from './click-logout.directive';
import { LoaderComponent } from './loader.component';
import { NoteLayoutComponent } from './note-layout.component';
import { NoteTitleComponent } from './note-title.component';
import { ToastComponent } from './toast.component';
import { InputComponent } from './input.component';
import { ToastsComponent } from './toasts.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { SafeResourcePipe } from './safe-resource.pipe';
import { UnescapePipe } from './unescape.pipe';
import { DialogComponent } from './dialogs/dialogs.component';
import { NgxdModule } from '@ngxd/core';
import { ExitFullscreenComponent } from './exit-fullscreen.component';
@NgModule({
  imports: [
    AngularCommonModule,
    NgxdModule,
  ],
  declarations: [
    ButtonComponent,
    IconComponent,
    DialogComponent,
    ClickOutsideDirective,
    ClickLoginDirective,
    ClickLogoutDirective,
    LoaderComponent,
    NoteLayoutComponent,
    NoteTitleComponent,
    ToastComponent,
    ToastsComponent,
    InputComponent,
    ExitFullscreenComponent,
    SafeHtmlPipe,
    SafeUrlPipe,
    SafeResourcePipe,
    UnescapePipe,
  ],
  exports: [
    ButtonComponent,
    IconComponent,
    DialogComponent,
    ClickOutsideDirective,
    ClickLoginDirective,
    ClickLogoutDirective,
    LoaderComponent,
    NoteLayoutComponent,
    NoteTitleComponent,
    ToastComponent,
    ToastsComponent,
    InputComponent,
    ExitFullscreenComponent,
    SafeHtmlPipe,
    SafeUrlPipe,
    SafeResourcePipe,
    UnescapePipe,
  ]
})
export class CommonModule { }
